exports = module.exports = require("../../../../../../../../textelements/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}", ""]);

// exports
